module.exports = __webpack_public_path__ + "static/media/box_card.1d010c82.jpg";